// Auth API endpoints
export const CHECK_EMAIL_API_URL = '/api/CheckEmail';
export const VERIFICATION_API_URL = '/api/Verification';
export const SIGNUP_API_URL = '/api/Signup';
export const LOGIN_API_URL = '/api/Login';
export const REFRESH_TOKEN_API_URL = '/api/Refresh';
export const FORGET_PASSWORD_URL = '/api/SendResetPasswordEmail';
export const RESET_PASSWORD_URL = '/api/ResetPassword';
export const GET_USER_URL = '/api/GetUser';
export const SET_USER_URL = '/api/SetUser';

// External URLs
export const IPIFY_API_URL = 'https://api.ipify.org?format=json';
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.BackPaddock.Opterra&hl=en';
export const APP_STORE_URL =
  'https://apps.apple.com/au/app/opterra/id6739559994';
export const BACK_PADDOCK_WEB_URL = process.env.REACT_APP_BACK_PADDOCK_WEB_URL;
export const CONTACT_SUPPORT_URL =
  'https://downloads.backpaddock.com.au/OnlineSupport.html';

// Organisation API endpoints
export const GET_ALL_ORGANISATIONS_URL = '/api/Organisation/GetAll';
export const CREATE_ORGANISATION_URL = '/api/Organisation/Create';
export const UPDATE_ORGANISATION_URL = '/api/Organisation/Update';
export const DELETE_ORGANISATION_URL = '/api/Organisation/Delete/{id}';

// Farm API endpoints
export const GET_ACTIVE_FARMS_BY_ORG_API_URL = '/api/Farm/GetByOrgActive';

// Zone API endpoints
export const GET_ACTIVE_ZONES_BY_ORG_API_URL = '/api/Zone/GetByOrgActive';
export const GET_ZONE_BY_ID_API_URL = '/api/Zone/GetById';

// Input API endpoints
export const GET_ACTIVE_INPUTS_BY_ORG_API_URL = '/api/Input/GetByOrgActive';
export const CREATE_INPUT_DOC_API_URL = '/api/Input/Create';
export const UPDATE_INPUT_DOC_API_URL = '/api/Input/UpdateDoc';
export const GET_INPUT_BY_ID_API_URL = '/api/Input/GetById';
export const UPSERT_APPLICATION_TASK_API_URL =
  '/api/Input/UpsertApplicationTask';
export const UPSERT_PRODUCTION_TASK_API_URL = '/api/Input/UpsertProductionTask';
export const UPSERT_CROP_ESTABLISHMENT_TASK_API_URL =
  '/api/Input/UpsertCropEstablishmentTask';
export const UPSERT_GENERIC_STEP_API_URL = '/api/Input/UpsertGenericStep';
export const UPSERT_APPLICATION_STEP_API_URL =
  '/api/Input/UpsertApplicationStep';
export const UPSERT_CROP_PROTECTION_STEP_API_URL =
  '/api/Input/UpsertCropProtectionStep';
export const UPSERT_ADJUVANT_STEP_API_URL = '/api/Input/UpsertAdjuvantStep';
export const UPSERT_SOIL_INPUT_STEP_API_URL = '/api/Input/UpsertSoilInputStep';
export const UPSERT_BIOSTIMULANT_STEP_API_URL =
  '/api/Input/UpsertBiostimulantStep';
export const UPSERT_PRODUCTION_STEP_API_URL = '/api/Input/UpsertProductionStep';
export const UPSERT_SEED_STEP_API_URL = '/api/Input/UpsertSeedStep';
export const UPSERT_SEED_DRESS_STEP_API_URL = '/api/Input/UpsertSeedDressStep';
export const DELETE_INPUT_DOC_API_URL = '/api/Input/Delete/{id}';
export const DELETE_INPUT_TASK_API_URL = '/api/Input/{id}/DeleteTask/{taskId}';
export const DELETE_INPUT_STEP_API_URL =
  '/api/Input/{id}/Task/{taskId}/DeleteStep/{stepId}';

// Global Catalogue API endpoints
export const G_SEARCH_API_URL = '/api/GSearch/Search';
/** Returns the base URL for paginated G collection counts; append /{orgId}/Size/{pageSize}[/Segment/{segmentId}]. */
export const gCollectionCountUrl = (collectionName: string) =>
  `/api/${collectionName}/GetCountByOrgActive`;
export const M_SEARCH_API_URL = '/api/MSearch/Search';
export const GET_ALL_GORGANISATION_URL = '/api/GOrganisation/GetAll';
export const GET_ALL_ACTIVE_UNIT_URL = '/api/GUnit/GetByOrgActive';
export const GET_ALL_ACTIVE_SEEDSPECIES_CROPS_URL =
  '/api/GSeedSpecies/GetByOrg/';
export const GET_SEEDSPECIES_BY_ID_URL = '/api/GSeedSpecies/GetById/';
export const GET_ALL_ACTIVE_SUPPLIER_NAMES_URL =
  '/api/GSupplier/GetAllActiveNames';

export const REFERENCE_COLLECTION_URLS = {
  CREATE: {},
  GET: {
    actionMode: '/api/GActionMode/GetAllActive',
    agSector: '/api/GAgSector/GetAllActive',
    chemicalGroup: '/api/GChemicalGroup/GetAllActive',
    genusSpecies: '/api/GGenusSpecies/GetAllActive',
    mainEndUse: '/api/GMainEndUse/GetAllActive',
    manufacturer: '/api/GManufacturer/GetAllActive',
    moaGroup: '/api/GMoaGroup/GetAllActive',
    parameter: '/api/GParameter/GetAllActive',
    productGrade: '/api/GProductGrade/GetAllActive',
    productGroup: '/api/GProductGroup/GetAllActive',
    physicalState: '/api/GPhysicalState/GetAllActive',
    segment: '/api/GSegment/GetAllActive',
    speciesType: '/api/GSpeciesType/GetAllActive',
    techStack: '/api/GTechStack/GetAllActive',
  },
  UPDATE: {
    actionMode: '/api/GActionMode/Update',
    agSector: '/api/GAgSector/Update',
    chemicalGroup: '/api/GChemicalGroup/Update',
    mainEndUse: '/api/GMainEndUse/Update',
    manufacturer: '/api/GManufacturer/Update',
    parameter: '/api/GParameter/Update',
    productGrade: '/api/GProductGrade/Update',
    productGroup: '/api/GProductGroup/Update',
    physicalState: '/api/GPhysicalState/Update',
    segment: '/api/GSegment/Update',
    techStack: '/api/GTechStack/Update',
  },
  DELETE: {
    actionMode: '/api/GActionMode/Delete',
    agSector: '/api/GAgSector/Delete',
    chemicalGroup: '/api/GChemicalGroup/Delete',
    mainEndUse: '/api/GMainEndUse/Delete',
    manufacturer: '/api/GManufacturer/Delete',
    parameter: '/api/GParameter/Delete',
    productGrade: '/api/GProductGrade/Delete',
    productGroup: '/api/GProductGroup/Delete',
    physicalState: '/api/GPhysicalState/Delete',
    segment: '/api/GSegment/Delete',
    techStack: '/api/GTechStack/Delete',
  },
};

export const REGULAR_COLLECTION_URLS = {
  CREATE: {
    biostimulant: '/api/GBiostimulant/Create',
    constraint: '/api/GConstraint/Create',
    operation: '/api/GOperation/Create',
    plantProduction: '/api/GPlantProduction/Create',
    plantProtection: '/api/GPlantProtection/Create',
    seedSpecies: '/api/GSeedSpecies/Create',
    soilInput: '/api/GSoilInput/Create',
  },
  GET: {
    // GChemical/GAdjuvant are read-only useWater-scoped views over the
    // GPlantProtection collection (OP-2420), used by the step picker only.
    adjuvant: '/api/GAdjuvant/GetByOrgActive',
    applicationMethod: '/api/GApplicationMethod/GetByOrgActive',
    biostimulant: '/api/GBiostimulant/GetByOrgActive',
    chemical: '/api/GChemical/GetByOrgActive',
    constraint: '/api/GConstraint/GetByOrgActive',
    operation: '/api/GOperation/GetByOrgActive',
    plantProduction: '/api/GPlantProduction/GetByOrgActive',
    plantProtection: '/api/GPlantProtection/GetByOrgActive',
    seedSpecies: '/api/GSeedSpecies/GetByOrgActive',
    soilInput: '/api/GSoilInput/GetByOrgActive',
    supplier: '/api/GSupplier/GetByOrgActive',
    timing: '/api/GTiming/GetByOrgActive',
  },
  UPDATE: {
    applicationMethod: '/api/GApplicationMethod/Update',
    biostimulant: '/api/GBiostimulant/Update',
    constraint: '/api/GConstraint/Update',
    operation: '/api/GOperation/Update',
    plantProduction: '/api/GPlantProduction/Update',
    plantProtection: '/api/GPlantProtection/Update',
    seedSpecies: '/api/GSeedSpecies/Update',
    soilInput: '/api/GSoilInput/Update',
    supplier: '/api/GSupplier/Update',
    timing: '/api/GTiming/Update',
    unit: '/api/GUnit/Update',
  },
  DELETE: {
    applicationMethod: '/api/GApplicationMethod/Delete',
    biostimulant: '/api/GBiostimulant/Delete',
    constraint: '/api/GConstraint/Delete',
    operation: '/api/GOperation/Delete',
    plantProduction: '/api/GPlantProduction/Delete',
    plantProtection: '/api/GPlantProtection/Delete',
    seedSpecies: '/api/GSeedSpecies/Delete',
    soilInput: '/api/GSoilInput/Delete',
    supplier: '/api/GSupplier/Delete',
    timing: '/api/GTiming/Delete',
    unit: '/api/GUnit/Delete',
  },
};

export const M_REGULAR_COLLECTION_URLS = {
  adjuvant: '/api/MAdjuvant/GetByOrgActive',
  biostimulant: '/api/MBiostimulant/GetByOrgActive',
  chemical: '/api/MChemical/GetByOrgActive',
  constraint: '/api/MConstraint/GetByOrgActive',
  operation: '/api/MOperation/GetByOrgActive',
  plantProtection: '/api/MPlantProtection/GetByOrgActive',
  seedSpecies: '/api/MSeedSpecies/GetByOrgActive',
  soilInput: '/api/MSoilInput/GetByOrgActive',
  timing: '/api/MTiming/GetByOrgActive',
};
